module.exports = __webpack_public_path__ + "img/fec6b39.png";